module.exports = __webpack_public_path__ + "static/media/account-icon.81fee9c4.svg";